export class MidUtil {
  static OPERATOR_LIST = {
    46692: '中華電信',
    46601: '遠傳電信',
    46697: '台灣大哥大',
    46605: '原亞太電信',
    46689: '原台灣之星'
  };

  static getOperatorName(mnoid, mnoname = undefined) {
    let operatorName = MidUtil.OPERATOR_LIST[mnoid] ?? mnoname ?? '';
    return operatorName !== '' ? operatorName : '不支援的電信業者';
  }
}
